import { type RefObject, useEffect, useId } from "react";
import type { Meeting } from "./meeting";

/**
 * Tells the meeting how wide a tile showing this person is, as it is laid out and each time it changes, and
 * that it is gone when the tile goes. The meeting uses it to ask for a smaller picture for a small tile
 * (layers.ts). Nothing is read for your own tile or for a tile given no meeting.
 */
export function useTileWidth(meeting: Pick<Meeting, "tileSized"> | undefined, id: string | undefined, el: RefObject<HTMLElement | null>): void {
  const key = useId();
  useEffect(() => {
    const node = el.current;
    if (!meeting || !id || !node) return;
    const read = () => meeting.tileSized(id, key, Math.round(node.getBoundingClientRect().width));
    read();
    const watch = new ResizeObserver(read);
    watch.observe(node);
    return () => {
      watch.disconnect();
      meeting.tileSized(id, key, null);
    };
  }, [meeting, id, key, el]);
}
